<template>
  <page title="Package Order">
    <div class="device-select"  style="display: flex">
      <label>{{deviceSn?deviceSn:'No device'}}</label>
    </div>
    <div class="box">
      <div class="p-top">
        <div>
          <van-image :src="item.flagUrl" width="149px"></van-image>
        </div>
        <div style="padding-left: 20px">
          <div class="text-r">{{item.country}} - {{item.text}}</div>
          <div class="text-b">
            <div class="num">{{i18n.Days_of_use}}:</div>
            <div class="cur">
              <van-stepper v-model="packageCount" @change="countChange" theme="round" button-size="22" disable-input  :disabled="packageObj.isPackage ? true : false"  />
            </div>
          </div>
        </div>
      </div>
      <div style="max-height: 40vh;overflow: auto;">
        <div v-for="item in packageDtlList" class="pakage-box flex-s" :class="packageClass(item)" @click="selectPack(item)" :key="item.skuId">
          <div class="pakage-text">{{ item.text }}</div>
          <div class="pakage-price">{{ item.price }}</div>
        </div>
      </div>
      <div class="time">
        <div class="time-l">{{i18n.Usage_time}}：</div>
        <div class="time-r" @click="showPicker = true">
          <van-icon name="arrow-down" style="padding: 10px"/>
          <label>{{ startTime }}</label>
        </div>
      </div>
      <div class="time">
        <div class="time-l">{{i18n.End_time}}</div>
        <div class="time-r">{{endTime}}</div>
      </div>
      <div class="time" v-if="showNote" style="display: none">
        <div class="time-l">{{i18n.Note}}:</div>
        <div class="time-t">{{packageName}} {{i18n.used_per_day}}</div>
      </div>
    </div>
    <div class="box" v-if="user == null || (user != null && !user.email)">
      <div class="bind-box">
        <div class="device-no"><span style="color: red">*</span>Mail</div>
        <van-field :disabled="!isSHowCode" v-model="email" class="device-input" ></van-field>
      </div>
      <div class="bind-box" v-if="isSHowCode">
        <div class="device-no">{{i18n.Code}}:</div>
        <van-field v-model="code"  class="device-input" >
          <template #button>
            <div class="login-code" @click="onCaptcha">
              <img :src="captchaUrl" />
            </div>
          </template>
        </van-field>
      </div>
      <div class="bind-box">
        <div class="device-no">{{i18n.Verification_Code}}:</div>
        <van-field v-model="verifyCode"  class="device-input" >
          <template #button>
            <van-button size="small" class="send-btn" type="primary" @click="onSendCode" :disabled="disabled">{{send}}</van-button>
          </template>
        </van-field>
      </div>
    </div>
    <div class="buy">
<!--      <div class="buy-l">{{packageObj.currencyName}}{{(packageObj.price * packageCount).toFixed(2)}} </div>-->
      <div class="buy-l">{{packageObj.currencyName}}{{totalAmount}} </div>
      <div class="buy-r">
        <button @click="buyNow">{{i18n.Buy_Now}}</button>
      </div>
    </div>
    <div style="width: 100%;height: 1px;padding-top: 70px">&nbsp;</div>
    <van-dialog v-model="show" title="" :show-cancel-button="false" :show-confirm-button="false" width="380px">
      <van-icon name="cross" class="cross-btn" @click="show = false" />
      <div class="package-title">
        {{i18n.ddd}}: <span>{{deviceSn}}</span>.{{i18n.ccc}}
      </div>
      <div class="method-box">
        <van-image :src="require('assets/imgs/mifi-back.png')" width="105px"></van-image>
        <van-image :src="require('assets/imgs/mifi_back02.png')" class="method-img-r" ></van-image>
        <div class="method-label">{{i18n.device_number}}</div>
      </div>
      <div class="method-btn">
        <button @click="continueBuy">{{i18n.Continue_purchasing}}</button>
      </div>
    </van-dialog>
    <van-datetime-picker
      v-if="showPicker"
      v-model="currentDate"
      type="datetime"
      :min-date="minDate"
      :max-date="maxDate"
      style="position: fixed;bottom: 0;left: 0;right: 0;z-index: 9999"
      :confirm-button-text= "i18nConfirm.msg_fail_confirm"
      :cancel-button-text= "i18nConfirm.msg_fail_cancel"
      @confirm="pickerConfirm"
      @cancel="pickerCancel"
    />
    <div style="position: fixed;right: 20px;bottom: 15%;">
      <a href="whatsapp://send?phone=+528129035171">
        <img src="../../assets/imgs/contactus/icon_whatsapp.png" alt="" height="40px" width="40px">
      </a>
    </div>
  </page>
</template>

<script>
import { mapState } from 'vuex'
import { MIFI_BIND, MIFI_DEVICEDEPOSIT, MIFI_PAY_LIST } from '../../apis/cabinet'
import dayjs from 'dayjs'
import { generateUUID } from '@/utils'
import { baseURL } from '@/utils/http'
import { SEND_CODE, USER_CAPTCHA, USER_INFO } from '@/apis/user'
export default {
  components: {
  },
  computed: {
    ...mapState(['mificode', 'mifisn', 'qrcode', 'cabinet', 'mifiPackage', 'user']),
    i18n () {
      return this.$t('packageOrder')
    },
    i18nPgeDetail () {
      return this.$t('packageDetail')
    },
    i18nConfirm () {
      return this.$t('confirm')
    },
    price () {
      let m = 0
      if (this.type === 'GM' && this.mifiData && this.isCheck) {
        m += Number(this.mifiData.depositAmount) + Number(this.mifiPackage.price)
        console.log(Number(this.mifiData.depositAmount), Number(this.mifiPackage.price))
      } else {
        m += Number(this.mifiPackage.price)
      }
      return m.toFixed(2)
    }
  },
  data () {
    return {
      type: 'GM',
      endTime: '',
      mifiData: null,
      isCheck: true,
      show: false,
      packageDtlList: [],
      minDate: new Date(),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
      showPicker: false,
      startTime: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'),
      skuId: '',
      country: '',
      item: null,
      captchaUrl: '',
      isSHowCode: true,
      email: '',
      sn: '',
      verifyCode: '',
      code: '',
      isPickUpShow: false,
      deviceSn: '',
      packageObj: null,
      packageCount: 1,
      send: 'Send',
      disabled: false,
      count: 59,
      timer: null,
      showNote: false,
      packageName: '',
      totalAmount: '',
      checkPrice: ''
    }
  },
  methods: {
    initPackage() {
      var skuId = this.item.skuId
      var country = this.item.country
      this.$post('chargenow/mifi/query', {
        'requestMethod': 'post',
        'url': '/mifi-open-api/wifiBase/packageDtlListBySkuId',
        'data': {
          'skuId': skuId,
          'country': country
        }
      }, (res) => {
        this.packageDtlList = JSON.parse(res.data)
        console.log(this.packageDtlList)
        this.packageDtlList = this.packageDtlList.map(item => {
          item.Day = item.packageName.split('-')[2].includes('Days') ? (item.packageName.split('-')[2]).split('Days')[0] : 1
          if (item.packageName.split('-')[2].includes('Days')) {
            item.text = `${item.packageName.split('-')[1]}/${(item.packageName.split('-')[2]).split('Days')[0]}天`
            item.isPackage = 1
          } else if (item.packageName.split('-')[2].includes('Unlimited')) {
            item.text = `${this.i18n.无限流量}/${item.Day}${this.i18n.天}`
            item.isPackage = 0
          } else {
            item.text = `${item.packageName.split('-')[2]}MB/${this.i18n.天}`
            item.isPackage = 0
          }
          return item
        })
        this.packageObj = { ...this.packageDtlList[0] }
        this.mifiPackage = this.packageObj
        this.packageName = this.packageObj.text
        this.totalAmount = this.packageObj.price
        this.endTime = dayjs(this.startTime).add(this.packageObj.Day, 'day').format('YYYY-MM-DD HH:mm:ss')
        console.log('流量套餐列表===', this.packageDtlList)
      }, error => {
        console.log(error)
      }, {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      })
    },
    onCaptcha () {
      this.code = ''
      this.uuid = generateUUID()
      this.captchaUrl = `${baseURL}${USER_CAPTCHA}?uuid=${this.uuid}`
    },
    onSendCode() {
      this.$loading(true)
      let url = `${SEND_CODE}?email=${this.email}&uuid=${this.uuid}&code=${this.code}`
      this.$post(url, {}, res => {
          this.$loading(false)
          this.disabled = true
          this.startCountdown();
        },
        err => {
          console.log(err)
          this.$loading(false)
          this.$toast(err)
          this.onCaptcha()
        },
        {
          headers: {
            agentOpenId: !this.isProd ? 'oDn2e4hi8M1iVtXcxm1uYpKTPEBE' : ''
          }
        }
      )
    },
    startCountdown() {
      this.timer = setInterval(() => {
        if (this.count > 0) {
          this.count -= 1;
          this.send = this.count + 's'
        } else {
          this.disabled = false
          this.send = 'Send'
          this.clearCountdown();
        }
      }, 1000);
    },
    clearCountdown() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    packageClass (item) {
      return item.skuId === this.packageObj.skuId ? 'h-pakage' : ''
    },
    selectPack (item) {
      this.packageObj = item
      this.mifiPackage = item
      this.packageCount = item.Day
      this.packageName = item.text
      this.showNote = false
      this.endTime = dayjs(this.startTime).add(item.Day, 'day').format('YYYY-MM-DD HH:mm:ss')
      this.totalAmount = item.price
      this.checkPrice = item.price
      this.item.text = item.text
    },
    countChange() {
      if (this.packageCount > 1) {
        this.showNote = true
      } else {
        this.showNote = false
      }
      this.endTime = dayjs(this.startTime).add(this.packageCount, 'day').format('YYYY-MM-DD HH:mm:ss')
      if (this.packageObj.isPackage === 0) {
        this.totalAmount = (this.packageObj.price * this.packageCount).toFixed(2)
      } else {
        this.totalAmount = (this.checkPrice).toFixed(2)
      }
    },
    onSubmit () {
      console.log('续购按钮')
      let order = {
      }
      if (this.mifiPackage) {
        order = {
          ...order,
          ...this.mifiPackage
        }
      }
      if (this.type === 'GM') {
        if (this.isCheck) {
          order.productId = this.mifiData.id
          order.depositAmount = this.mifiData.depositAmount
        }
        order.payType = 'GM'
        order.xugou = true
      } else {
        order.productSendSn = this.mifisn
        order.xugou = true
      }
      order.startTime = this.startTime
      order.endTime = this.endTime
      order.myStartime = this.endTime
      this.$store.commit('mifiOrder', order)
      this.$router.push({ path: '/confirm', query: { price: this.price, payType: 'mifi' } })
    },
    getMifiData () {
      this.$loading(true)
      this.$get(
        `${MIFI_DEVICEDEPOSIT}`,
        {},
        resp => {
          this.$loading(false)
          this.mifiData = resp.data
          console.log('数据===', this.mifiData)
        },
        error => {
          this.$loading(false)
          this.$toast(error)
        }
      )
    },
    pickerCancel() {
      this.showPicker = false
    },
    pickerConfirm(value) {
      this.startTime = dayjs(value).format('YYYY-MM-DD HH:mm:ss')
      this.endTime = dayjs(this.startTime).add(this.packageCount, 'day').format('YYYY-MM-DD HH:mm:ss')
      this.showPicker = false
    },
    buyNow() {
      if ((this.code && this.email && this.verifyCode) || (this.user != null && this.user.email)) {
        this.$loading(true)
        let url = `${MIFI_PAY_LIST}?email=${this.email}&deviceSn=${this.deviceSn}&verifyCode=${this.verifyCode}&currency=${this.packageObj.currency}`
        this.$post(url, {
          }, res => {
            this.$loading(false)
            if (res.data.token) {
              this.$store.commit('token', res.data.token)
              this.loadUser()
            }
            this.show = true
          },
          err => {
            this.$loading(false)
            this.$toast(err)
            this.onCaptcha()
          },
          {
            headers: {
              agentOpenId: !this.isProd ? 'oDn2e4hi8M1iVtXcxm1uYpKTPEBE' : '' // 正式
              //  agentOpenId: !this.isProd ? 'BJCD0000000000000000000000000001' : ''
            }
          }
        )
      }
    },
    continueBuy() {
      let order = this.packageObj
      order.startTime = this.startTime
      order.endTime = this.endTime
      order.productSendSn = this.deviceSn
    //  order.xugou = false
      this.$store.commit("mifiOrder", order)
      this.$router.push({
        path: "/confirm",
        query: { price: this.totalAmount, payType: "mifi", currency: this.packageObj.currency, 'mifisn': this.deviceSn }
      })
    },
    loadUser () {
      this.$get(
        USER_INFO,
        {},
        res => {
          if (res.user) {
            this.$store.commit('user', res.user)
          }
        },
        err => {
          this.$loading(false)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: err,
            showCancel: false
          }).then(() => {
            this.$store.commit('token', null)
          })
        }
      )
    }
  },
  created () {
    var it = this.$route.query.item
    this.item = JSON.parse(it)
    this.deviceSn = this.$route.query.deviceSn
    this.initPackage()
  //  this.getMifiData()
  //  this.startTime = dayjs(this.mifiPackage.myStartime).format('YYYY-MM-DD HH:mm:ss')
  //  this.endTime = dayjs(this.startTime).add(this.mifiPackage.selectDays, 'day').format('YYYY-MM-DD HH:mm:ss')
  },
  mounted () {
    this.onCaptcha()
  }
}
</script>

<style lang="less" scoped>
.box{
  margin: 20px;
  box-shadow: 0px 6px 10px 1px rgba(0,0,0,0.05);
  border-radius: 18px 18px 18px 18px;
  background: #ffffff;
}
.p-top{
  display: flex;
  padding: 20px;
}
.text-r{
  font-family: Montserrat, Montserrat;
  font-weight: 500;
  font-size: 30px;
}
.text-b{
  margin-top: 60px;
  display: flex;
}
.num{
  font-family: Montserrat, Montserrat;
  font-size: 22px;
  color: #666666;
}
.cur{
  text-align: right;
  width: 60%;
  font-family: Montserrat, Montserrat;
  font-weight: bold;
  font-size: 36px;
  color: #FF1919;
  margin-top: -7px;
}
.pakage-box {
  margin: 20px;
  position: relative;
  // width: 100%;
  background: #FFFFFF;
  border-radius: 18px 18px 18px 18px;
  border: 1px solid #D1D1D1;
  padding: 17px 20px;
  .pakage-text{
    width: 70%;
    font-family: Montserrat, Montserrat;
    font-weight: 400;
    font-size: 22px;
    color: #333333;
    line-height: 30px;
  }
  .pakage-price {
    font-size: 30px;
    font-weight: bold;
    color: #FF1919;
  }
}
.time-l{
  font-family: Montserrat, Montserrat;
  font-weight: 400;
  font-size: 28px;
  color: #999999;
  width: 40%;
}
.time-r{
  font-family: Montserrat, Montserrat;
  font-weight: 400;
  font-size: 28px;
  color: #333333;
  width: 60%;
  text-align: right;
  label{
    font-family: Montserrat, Montserrat;
    font-weight: 500;
    font-size: 22px;
    color: #666666;
    padding: 11px 20px;
    border-radius: 8px 8px 8px 8px;
    border: 3px solid #1EBE86;
  }
}
.time{
  padding: 10px 20px 10px 20px;
  margin: 18px 0 4px 0;
  display: flex;
}
.time-t{
  font-family: Montserrat, Montserrat;
  font-weight: 400;
  font-size: 22px;
  color: #333333;
  width: 60%;
  text-align: right;
}
.bind-box{
  padding: 20px;
}
.device-no{
  font-family: Montserrat, Montserrat;
  font-weight: bold;
  font-size: 30px;
  color: #1A2229;
}
.device-input{
  width: 100%;
  height: 90px;
  background: #FFFFFF;
  border-radius: 49px 49px 49px 49px;
  border: 2px solid #D1D1D1;
  margin-top: 20px;
}
.send-btn{
  border: none;
  background: #ffffff;
  color: #1EBE86;
  font-size: 26px;
}
.buy{
  display: flex;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: -webkit-fill-available;
  background: #eeecec;
  padding: 20px;
  .buy-l{
    width: 40%;
    color: #FF1919;
    font-family: Montserrat, Montserrat;
    font-weight: bold;
    font-size: 40px;
    color: #FF1919;
    align-content: center;
  }
  .buy-r{
    width: 60%;
    text-align: right;
    button{
      width: 253px;
      height: 98px;
      background: #1EBE86;
      border-radius: 60px 60px 60px 60px;
      border: none;
      font-weight: bold;
      font-size: 36px;
      color: #FFFFFF;
    }
  }
}
.package-title{
  text-align: center;
  padding: 70px 40px 30px 40px;
  font-family: Montserrat, Montserrat;
  color: #333333;
  font-family: Montserrat, Montserrat;
  font-size: 28px;
  span{
    font-weight: bold;
  }
}
.cross-btn{
  position: absolute;
  right: 30px;
  top: 30px;
  font-size: 40px;
}
.method-img-r{
  position: absolute;
  margin-left: 85px;
  width: 244px;
}
.method-box{
  padding: 20px 20px 40px 20px;
  .method-label{
    font-family: Montserrat, Montserrat;
    font-weight: 400;
    font-size: 22px;
    color: #333333;
    width: 4.2rem;
    margin-left: 3.5rem;
    margin-top: -1.3rem;
  }
}
.method-btn{
  width: 100%;
  text-align: center;
  padding: 30px 0 30px 0;
  button{
    background: #FFFFFF;
    border-radius: 40px 40px 40px 40px;
    border: 2px solid #1EBE86;
    font-size: 24px;
    color: #1EBE86;
    width: 380px;
    height: 76px;
  }
}
.login-code {
  img {
    width: 180px;
    height: 60px;
    border: none;
    margin-top: -3px;
  }
}
.h-pakage {
  border: 3px solid #00AB46;
}
.device-select{
  text-align: left;
  border-left: 5px solid #1EBE86;
  margin-left: 20px;
  margin: 20px;
  label{
    font-weight: bold;
    font-size: 32px;
    color: #333333;
    margin-left: 15px;
  }
}
</style>
